import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'

export const STORAGE_KEY = 'forwalk-planner'

export const parseSettings = (value) => {
    try {
        return JSON.parse(value) 
    } catch (error) {
        return {}
    }
}


export const getPlannerOptions = () => {
  return Object.assign(
    window.PLANNER_OPTIONS || {}, {
      options: parseSettings(localStorage.getItem(STORAGE_KEY)),
      checkpoints : []
    }
  )
}


const initialState = getPlannerOptions()

const plannerSlice = createSlice({
  name: 'planner',
  initialState,
  reducers: {
    setPlannerOption(state, action) {
      Object.assign(state.options, action.payload)
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state.options));
    }
  }
})


export const usePlannerOptions = () => useSelector( state => state.planner.options )
export const usePlannerCheckPoints = () => useSelector( state => state.planner.checkpoints )
export const { setPlannerOption } = plannerSlice.actions
export default plannerSlice
